const prefix = "[ANNOTATIONS]";

export default {
    FETCH_ANNOTATIONS_REQUEST: `${prefix} FETCH_ANNOTATIONS_REQUEST`,
    FETCH_ANNOTATIONS_SUCCESS: `${prefix} FETCH_ANNOTATIONS_SUCCESS`,
    FETCH_ANNOTATIONS_FAILED: `${prefix} FETCH_ANNOTATIONS_FAILED`,

    SUBMIT_ANNOTATIONS_REQUEST: `${prefix} SUBMIT_ANNOTATIONS_REQUEST`,
    SUBMIT_ANNOTATIONS_SUCCESS: `${prefix} SUBMIT_ANNOTATIONS_SUCCESS`,
    SUBMIT_ANNOTATIONS_FAILED: `${prefix} SUBMIT_ANNOTATIONS_FAILED`,

    SUBMIT_IS_ANNOTATION_REVIEWED_REQUEST: `${prefix} SUBMIT_IS_ANNOTATION_REVIEWED_REQUEST`,
    SUBMIT_IS_ANNOTATION_REVIEWED_SUCCESS: `${prefix} SUBMIT_IS_ANNOTATION_REVIEWED_SUCCESS`,
    SUBMIT_IS_ANNOTATION_REVIEWED_FAILED: `${prefix} SUBMIT_IS_ANNOTATION_REVIEWED_FAILED`,

    REMOVE_ANNOTATION_REQUEST: `${prefix} REMOVE_ANNOTATION_REQUEST`,
    REMOVE_ANNOTATION_SUCCESS: `${prefix} REMOVE_ANNOTATION_SUCCESS`,
    REMOVE_ANNOTATION_FAILED: `${prefix} REMOVE_ANNOTATION_FAILED`,

    ATTACH_ASSET_REQUEST: `${prefix} ATTACH_ASSET_REQUEST`,
    ATTACH_ASSET_SUCCESS: `${prefix} ATTACH_ASSET_SUCCESS`,
    ATTACH_ASSET_FAILED: `${prefix} ATTACH_ASSET_FAILED`,

    REMOVE_ASSET_REQUEST: `${prefix} REMOVE_ASSET_REQUEST`,
    REMOVE_ASSET_SUCCESS: `${prefix} REMOVE_ASSET_SUCCESS`,
    REMOVE_ASSET_FAILED: `${prefix} REMOVE_ASSET_FAILED`,

    SET_SELECTED_ANNOTATION: `${prefix} SET_SELECTED_ANNOTATION`,
    RESET_ANNOTATION_STATE: `${prefix} RESET_ANNOTATION_STATE`,
    ADD_ANNOTATION: `${prefix} ADD_ANNOTATION`,
    UPDATE_ANNOTATIONS: `${prefix} UPDATE_ANNOTATIONS`,
};
